module.exports = "<checkout [popoverController]=\"props.popoverController\" [maxPayment]=\"props.maxPayment\" [project]=\"props.project\"></checkout>"